import React from "react";
import Marquee from "react-fast-marquee";

const words = ["Machine Learning", "Risk Modelling", "Forecasting", "Data Pipelines", "Model Evaluation"];

export const MarqueeSection = () => {
  return (
    <section aria-hidden="true" data-testid="marquee-section" className="border-y border-[#E5E5DF] bg-[#0A0A0A] py-10 md:py-14">
      <Marquee speed={38} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="marquee-item flex items-center">
            <span className="font-display italic text-[#F9F9F7] text-5xl md:text-7xl px-8 md:px-14">
              {w}
            </span>
            <span className="font-mono text-[#D1D1C7] text-xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default MarqueeSection;
